module.exports = __webpack_public_path__ + "img/derby-county.195f4a1f.png";